import { ChangeDetectionStrategy, Component } from '@angular/core';

import { closeLightIcon } from '../../../icons';
import { FilterService } from '../../filter-service/filter.service';

@Component({
    selector: 'app-active-facets',
    template: `
    <div class="active-facets" *ngIf="filterService.enrichedActiveFacets | async as AF">
        <app-button *ngIf="AF?.length" buttonClass="active-facets__button button--quinary" (handleClick)="filterService.resetFacets()">
            <span>{{ 'filterpage.facets____clear_all_selected_facets' | translate }}</span>
            <i class="button__icon">${closeLightIcon}</i>
        </app-button>

        <app-button
            buttonClass="active-facets__button button--quinary"
            *ngFor="let facet of AF"
            (handleClick)="filterService.setFacet({ facet: facet.facet, option: { key: facet.option.key, selected: true } })"
        >
            <ng-container [ngSwitch]="facet.facet">
                <span *ngSwitchCase="'isNew'">{{ 'filterpage.facets____filter_name____show_only_new_cars' | translate }}</span>
                <span *ngSwitchCase="'isVan'">{{ 'filterpage.facets____filter_name____show_only_vans' | translate }}</span>
                <span *ngSwitchCase="'mileage'">{{ facet.option.key }} {{ 'filterpage.facets____filter_name____mileage' | translate }}</span>
                <span *ngSwitchCase="'price'">{{ facet.option.key }} {{ 'filterpage.facets____filter_name____price' | translate }}</span>
                <span *ngSwitchCase="'santanderPaymentPerMonth'"
                    >{{ facet.option.key }} {{ 'filterpage.facets____filter_name____loan_price_per_month' | translate }}</span
                >
                <span *ngSwitchCase="'leasingPricePrivateFinancial'">{{ facet.option.key }} {{ 'filterpage.facets____filter_name____leasing_price_private_financial' | translate }}</span>
                <span *ngSwitchCase="'leasingPricePrivateOperational'">{{ facet.option.key }} {{ 'filterpage.facets____filter_name____leasing_price_private_operational' | translate }}</span>
                <span *ngSwitchCase="'leasingPriceBusinessOperational'">{{ facet.option.key }} {{ 'filterpage.facets____filter_name____leasing_price_business_operational' | translate }}</span>
                <span *ngSwitchCase="'leasingPriceBusinessFinancial'">{{ facet.option.key }} {{ 'filterpage.facets____filter_name____leasing_price_business_financial' | translate }}</span>
                <span *ngSwitchDefault>{{ facet.option.label || facet.option.key | decodeURI}}</span>
            </ng-container>

            <i class="button__icon">${closeLightIcon}</i>
        </app-button>
    </div>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActiveFacetsComponent {
    constructor(public filterService: FilterService) {}
}
